


















































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const Creditors = namespace("CreditorsModule");
import Paginate from "@/components/Paginate.vue";
import { BOverlay } from "bootstrap-vue";

@Component({
  name: "Creditor",
  components: {
    Paginate,
    BOverlay,
  },
})
export default class Creditor extends Vue {
  private filter = {
    Name: "",
    Number: 0,
    sort: "desc",
    index: "NameSort",
  };
  private creditors = [];
  private creditorName = "";
  private creditorNumber = "";
  private loading = true;

  private dataPagination = {
    perPage: 0,
    totalRow: 0,
    currentPage: 0,
    limit: 0,
  };

  pageChange(params: any) {
    this.getItemPerPage({
      page: params.currentPage,
      filter: this.filterQuery(),
    }).then(
      (response) => {
        this.creditors = response.creditorList;
        if (response.Paginate) {
          this.dataPagination = response.Paginate;
        }
      }
    );
  }

  private filterQuery() {
    const filter = this.filter;
    const filterData: any = {};

    if (this.creditorName !== undefined) {
      this.filter.Name = this.creditorName;
    }
    if (this.creditorNumber !== undefined) {
      this.filter.Number = parseInt(this.creditorNumber);
    }
    //index using and sort
    if (filter.index) {
      filterData.Index = filter.index;
    }
    if (filter.sort) {
      filterData.Sort = filter.sort;
    }
    filterData.Filter = this.makeFilter();
    return filterData;
  }

  private makeFilter() {
    const filter = this.filter;
    const Filter = [];
    if (filter.Name) {
      Filter.push({
        Key: "Name",
        Operator: "contains",
        Value: this.creditorName,
      });
    }
    if (filter.Number) {
      Filter.push({
        Key: "Creditor",
        Value: parseInt(this.creditorNumber),
      });
    }
    return Filter;
  }
  // ---- End Handling Paginate ----

  public clickCreditorDetail(creditorId: any) {
    this.$router.push({
      name: "CreditorDetails",
      params: { creditorId: creditorId },
    });
  }
  clickCreditorAdd() {
    this.$router.push({ name: "CreditorAdd" });
  }
  onSearch() {
    this.loading = true;
    this.retrieveCreditors(this.filterQuery()).then(
      (response) => {
        this.dataPagination = response.Paginate;
        this.creditors = response.creditorList;
        this.loading = false;
      }
    );
  }

  created() {
    this.onSearch();
  }

  @Creditors.State
  private creditorData!: Array<any>;

  @Creditors.Action
  public retrieveCreditors!: (params: any) => Promise<any>;

  @Creditors.Action
  public getItemPerPage!: (params: any) => Promise<any>;
}
